import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './ShopDiscoverResults.scss';

import { syncShopFeatures } from '../../Actions/FeaturedActions';
import { getShopFeaturedResultsForType, getFeaturedTypeDisplayData } from '../../Helpers/featured_helpers';

import ShopTile from '../Shop/ShopTile';
import ShopFeaturesAddNewButton from './Elements/ShopFeaturesAddNewButton';

const ShopDiscoverResults = props => {
  const results = getShopFeaturedResultsForType(props.featured, props.tab, props.activeSection);
  const displayData = getFeaturedTypeDisplayData(props.tab);
  const rows = [
    {
      type: 'has-feature first',
      row_results: [results.slice(0, 1), results.slice(1, 5)]
    },
    {
      type: 'row',
      row_results: [results.slice(5, 9)]
    },
    {
      type: 'has-feature last',
      row_results: [results.slice(9, 13), results.slice(13, 14)]
    },
    {
      type: 'row',
      row_results: [results.slice(14, 18)]
    },
    {
      type: 'row',
      row_results: [results.slice(18, 22)]
    },
    {
      type: 'row',
      row_results: [results.slice(22, 26)]
    },
    {
      type: 'row',
      row_results: [results.slice(30, 34)]
    },
    {
      type: 'row',
      row_results: [results.slice(35, 39)]
    }
  ].filter(row => _.flatten(row.row_results).length);

  return (
    <div className='shop-discover-results-container'>
      <div className='results-header'>
        <div className='line line-left' />
        <div className='label'>Featured {displayData.pluralType}</div>
        <div className='line line-right' />
      </div>
      <div className='shop-discover-results'>
        {rows.map(row => {
          const { row_results, type } = row;
          if (!row_results?.length) return null;
          return (
            <div key={row.type} className={cn('row', type)}>
              {row_results.map(tiles => {
                if (!tiles.length) return null;
                return (
                  <div className={cn('row-tiles', type)} key={tiles[0].id}>
                    {tiles.map(feature => {
                      const isFeature = tiles.length === 1;
                      return (
                        <div className={cn('tile', { feature: isFeature })} key={feature.id}>
                          {feature?.id ? (
                            <ShopTile
                              featured={props.featured}
                              feature={feature}
                              activeSection={props.activeSection}
                              syncShopFeatures={props.syncShopFeatures}
                            />
                          ) : (
                            <div className='tile-placeholder' />
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      {window.__ADMIN_CONTROL_MODE__ && (
        <div className='admin-section'>
          <ShopFeaturesAddNewButton type={props.tab} />
        </div>
      )}
    </div>
  );
};

ShopDiscoverResults.propTypes = {
  featured: PropTypes.object.isRequired,

  // From Outside
  tab: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const { featured } = state;
  return { featured };
};

export default connect(mapStateToProps, {
  syncShopFeatures
})(ShopDiscoverResults);
